/* eslint-disable check-file/filename-naming-convention -- styles.ts does not follow the usual naming convention */
import type { ButtonProps } from "tamagui";

import { ColorToken } from "@/ui/theme/tokens";

const DisabledContentColor = ColorToken.NeutralTertiary;

const DisabledSolidStyles: ButtonProps["disabledStyle"] = {
  backgroundColor: ColorToken.NeutralLine,
  borderColor: ColorToken.NeutralLine,
};

const PrimaryStyles: ButtonProps = {
  backgroundColor: ColorToken.Primary100,
  borderColor: ColorToken.Transparent,
  borderWidth: 1,
  color: ColorToken.NeutralBackgroundPrimary,
  disabledStyle: DisabledSolidStyles,
  // web-only: override Tamagui's default gray hover with the base color (no-op on native)
  hoverStyle: {
    backgroundColor: ColorToken.Primary100,
    borderColor: ColorToken.Transparent,
  },
  pressStyle: {
    backgroundColor: ColorToken.ButtonPrimaryActive,
    borderColor: ColorToken.Transparent,
  },
};

// One-off alternative style for primary buttons on a background color
// where the default primary button disabled state doesn't provide enough contrast
const PrimaryOnBackgroundStyles: ButtonProps = {
  ...PrimaryStyles,
  disabledStyle: {
    opacity: 0.5,
  },
};

const SecondaryStyles: ButtonProps = {
  backgroundColor: ColorToken.Transparent,
  borderColor: ColorToken.Primary100,
  borderWidth: 1,
  color: ColorToken.NeutralBackgroundPrimary,
  disabledStyle: {
    backgroundColor: ColorToken.Transparent,
    borderColor: ColorToken.NeutralTertiary,
  },
  // web-only: override Tamagui's default gray hover with the base color (no-op on native)
  hoverStyle: {
    backgroundColor: ColorToken.Transparent,
    borderColor: ColorToken.Primary100,
  },
  pressStyle: {
    backgroundColor: ColorToken.Primary10,
    borderColor: ColorToken.Primary100,
  },
};

const TertiaryStyles: ButtonProps = {
  backgroundColor: ColorToken.Transparent,
  borderWidth: 0,
  color: ColorToken.Primary100,
  disabledStyle: {
    backgroundColor: ColorToken.Transparent,
  },
  // web-only: override Tamagui's default gray hover with the base color (no-op on native)
  hoverStyle: {
    backgroundColor: ColorToken.Transparent,
  },
  pressStyle: {
    backgroundColor: ColorToken.Transparent,
  },
};

const TertiaryCriticalStyles: ButtonProps = {
  ...TertiaryStyles,
  color: ColorToken.NotificationCritical,
};

const AccentLimeStyles: ButtonProps = {
  backgroundColor: ColorToken.AccentLime,
  borderColor: ColorToken.AccentLime,
  borderWidth: 1,
  color: ColorToken.NeutralBackgroundPrimary,
  disabledStyle: DisabledSolidStyles,
  // web-only: override Tamagui's default gray hover with the base color (no-op on native)
  hoverStyle: {
    backgroundColor: ColorToken.AccentLime,
    borderColor: ColorToken.AccentLime,
  },
  pressStyle: {
    backgroundColor: ColorToken.ButtonAccentLimeActive,
    borderColor: ColorToken.ButtonAccentLimeActive,
  },
};

const AccentCriticalStyles: ButtonProps = {
  backgroundColor: ColorToken.NotificationCritical,
  borderColor: ColorToken.Transparent,
  borderWidth: 1,
  color: ColorToken.NeutralBackgroundPrimary,
  disabledStyle: DisabledSolidStyles,
  // web-only: override Tamagui's default gray hover with the base color (no-op on native)
  hoverStyle: {
    backgroundColor: ColorToken.NotificationCritical,
    borderColor: ColorToken.Transparent,
  },
  pressStyle: {
    backgroundColor: ColorToken.ButtonAccentCriticalActive,
    borderColor: ColorToken.Transparent,
  },
};

const AccentBlueStyles: ButtonProps = {
  backgroundColor: ColorToken.AccentBlue,
  borderColor: ColorToken.Transparent,
  borderWidth: 1,
  color: ColorToken.NeutralBackgroundPrimary,
  disabledStyle: DisabledSolidStyles,
  // web-only: override Tamagui's default gray hover with the base color (no-op on native)
  hoverStyle: {
    backgroundColor: ColorToken.AccentBlue,
    borderColor: ColorToken.Transparent,
  },
  pressStyle: {
    backgroundColor: ColorToken.ButtonAccentBlueActive,
    borderColor: ColorToken.Transparent,
  },
};

const ToggleableStyles: ButtonProps = {
  backgroundColor: ColorToken.Transparent,
  borderColor: ColorToken.NeutralLine,
  borderWidth: 1,
  color: ColorToken.NeutralBackgroundPrimary,
  disabledStyle: {
    backgroundColor: ColorToken.Transparent,
    borderColor: ColorToken.NeutralTertiary,
  },
  // web-only: override Tamagui's default gray hover with the base color (no-op on native)
  hoverStyle: {
    backgroundColor: ColorToken.Transparent,
    borderColor: ColorToken.NeutralLine,
  },
  pressStyle: {
    backgroundColor: ColorToken.Primary10,
    borderColor: ColorToken.NeutralLine,
  },
};

export {
  AccentBlueStyles,
  AccentCriticalStyles,
  AccentLimeStyles,
  DisabledContentColor,
  DisabledSolidStyles,
  PrimaryOnBackgroundStyles,
  PrimaryStyles,
  SecondaryStyles,
  TertiaryCriticalStyles,
  TertiaryStyles,
  ToggleableStyles,
};
